var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsChartTypesStacked = function SvgIconsChartTypesStacked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 9a1 1 0 0 1 .993.883L19 10v2a1 1 0 0 1-1.993.117L17 12v-2a1 1 0 0 1 1-1zm0 5a1 1 0 0 1 .993.883L19 15v5a1 1 0 0 1-1.993.117L17 20v-5a1 1 0 0 1 1-1zM12 3a1 1 0 0 1 .993.883L13 4v6a1 1 0 0 1-1.993.117L11 10V4a1 1 0 0 1 1-1zm0 13a1 1 0 0 1 .993.883L13 20a1 1 0 0 1-1.993.117L11 20v-3a1 1 0 0 1 1-1zm0-4a1 1 0 0 1 .993.883L13 14a1 1 0 0 1-1.993.117L11 14v-1a1 1 0 0 1 1-1zm-6 6a1 1 0 0 1 .993.883L7 19v1a1 1 0 0 1-1.993.117L5 20v-1a1 1 0 0 1 1-1zm0-7a1 1 0 0 1 .993.883L7 12v4a1 1 0 0 1-1.993.117L5 16v-4a1 1 0 0 1 1-1z"
  }))));
};
export default SvgIconsChartTypesStacked;